import Api from './api'

const searchRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/auctions/search', {
        headers: {
            Authorization: 'Bearer ' + access_token,
        },
        params: query
    })
}

const getLotsNumbers = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/numbers', { headers: { Authorization: 'Bearer ' + access_token } })
}

export default { searchRequest, getLotsNumbers }



// WEBPACK FOOTER //
// ./src/api/apiSearch.js